import {getAxios} from './axios';
import {addAuthTokenData} from './member';

export function getWallMaterials(params) {
    let axios = getAxios();

    return axios.request({
        url: '/wall_materials/',
        method: 'get',
        params: addAuthTokenData(params)
    });
}



// WEBPACK FOOTER //
// ./src/backend-helpers/wallMaterials.js